import { MultiSelect, SelectOptionType } from "@aidkitorg/component-library";
import { useCallback, useMemo } from "react";
import { useLocalizedStrings } from "../../../../Localization";
import { FilterWrapper } from "./FilterWrapper";

interface EventTypeFilterProps {
  selectedEvents: string[];
  availableEvents: string[];
  onEventsChange: (events: string[]) => void;
}

export const EventTypeFilter: React.FC<EventTypeFilterProps> = ({
  selectedEvents,
  availableEvents,
  onEventsChange,
}) => {
  const L = useLocalizedStrings();

  const eventOptions = useMemo(() => {
    return availableEvents.map(event => ({
      value: event,
      label: L.admin_panel.audit_logs.events[event as keyof typeof L.admin_panel.audit_logs.events] || event,
    }));
  }, [availableEvents, L]);

  const selectedEventOptions = useMemo(() => {
    return eventOptions.filter(option => selectedEvents.includes(option.value));
  }, [eventOptions, selectedEvents]);

  const handleEventsChange = useCallback((selectedOptions: SelectOptionType[]) => {
    const newEvents = selectedOptions.map(option => option.value);
    onEventsChange(newEvents);
  }, [onEventsChange]);

  return (
    <FilterWrapper label={L.admin_panel.audit_logs.event_types}>
      <MultiSelect
        hideLabel
        label={L.admin_panel.audit_logs.event_types}
        description={L.admin_panel.audit_logs.select_event_types_description}
        options={eventOptions}
        value={selectedEventOptions}
        onChange={handleEventsChange}
        placeholder={L.admin_panel.audit_logs.select_event_types_placeholder}
        searchable={true}
      />
    </FilterWrapper>
  );
};
